import React, { useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { addHoliday } from "../../store/slices/holiday";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

export default function AddHoliday() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    fromDate: "",
    toDate: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {};

    // Required field validation
    if (!formData.name.trim()) {
      newErrors.name = "Please enter holiday name";
    }

    if (!formData.fromDate) {
      newErrors.fromDate = "Please select from date";
    }

    if (!formData.toDate) {
      newErrors.toDate = "Please select to date";
    }

    // Date logic validation
    if (formData.fromDate && formData.toDate) {
      const fromDate = new Date(formData.fromDate);
      const toDate = new Date(formData.toDate);

      // normalize time (important)
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);



      // To date cannot be before from date
      if (toDate < fromDate) {
        newErrors.toDate = "To Date must be same or after From Date";
      }
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const payload = {
      name: formData.name,
      fromDate: formData.fromDate,
      toDate: formData.toDate,
    };

    dispatch(addHoliday(payload))
      .unwrap()
      .then(() => {
        toast.success("Holiday added successfully ");
        navigate("/institute/holidays");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.message ||
          "Failed to add holiday "
        );
      });
  };

  const today = new Date();
  today.setMinutes(today.getMinutes() - today.getTimezoneOffset());

  const minDate = new Date(today);
  minDate.setFullYear(today.getFullYear() - 1);

  const maxDate = new Date(today);
  maxDate.setFullYear(today.getFullYear() + 1);

  const minDateStr = minDate.toISOString().split("T")[0];
  const maxDateStr = maxDate.toISOString().split("T")[0];

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/holidays">Holiday</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Holiday</span>
          </div>

        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* Holiday Name */}
            <Col lg={4} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Holiday Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter holiday name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </Form.Group>
            </Col>

            {/* From Date */}
            <Col lg={4} md={6} sm={12}>
              <Form.Group>
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  name="fromDate"
                  value={formData.fromDate}
                  min={minDateStr}
                  max={maxDateStr}
                  onChange={handleChange}
                />
                {errors.fromDate && (
                  <small className="text-danger">{errors.fromDate}</small>
                )}
              </Form.Group>
            </Col>

            {/* To Date */}
            <Col lg={4} md={6} sm={12}>
              <Form.Group>
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  name="toDate"
                  value={formData.toDate}
                  min={formData.fromDate || minDateStr}
                  max={maxDateStr}
                  onChange={handleChange}
                />
                {errors.toDate && (
                  <small className="text-danger">{errors.toDate}</small>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Actions */}
          <div className="ah-actions mt-5">
            <button
              className="btn-cancel"
              style={{ color: "black" }}
              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button className="btn-submit" type="submit">
              Submit
            </button>
          </div>
        </Form>
      </div>
    </>
  );
}
